function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M507.3,238.5l-52.2-46.1V71.1c0-7.9-6.4-14.2-14.2-14.2H384c-7.9,0-14.2,6.4-14.2,14.2v45.9l-90-79.4 c-13.5-12.2-34-12.2-47.5,0L4.7,238.5c-5.8,5.2-6.3,14.2-1.1,20.1c0,0,0,0,0,0l19,21.1c5.2,5.8,14.2,6.3,20.1,1.1c0,0,0,0,0,0 L246.6,101c5.4-4.7,13.4-4.7,18.8,0l203.8,179.8c5.8,5.3,14.8,4.8,20.1-1.1c0,0,0,0,0,0l19-21.2 C513.6,252.7,513.1,243.7,507.3,238.5z M256,130.7L61.8,302c-1.4,1.3-3.3,1.9-4.9,3v164.4c0,7.9,6.4,14.2,14.2,14.2h113.8 c7.9,0,14.2-6.4,14.2-14.2V355.5c0-7.9,6.4-14.2,14.2-14.2h85.3c7.9,0,14.2,6.4,14.2,14.2v113.8c0,7.9,6.4,14.2,14.2,14.2h113.8 c7.9,0,14.2-6.4,14.2-14.2V305c-1.5-1-3.3-1.6-4.7-2.8L256,130.7z"
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d3b4021b.svg";
export { ForwardRef as ReactComponent };